import { LabelItemDTO } from '@api/models/label-item.dto';

export interface AdvancedLabelModel extends LabelItemDTO {
  filter: string;
  part: number;
}
